// src/components/Footer/Footer.js
import React from 'react';
import './Footer.css';
import sgbauLogo from '../../images/sgb-amravti.png';
import maharashtraLogo from '../../images/govt-maharashtra.png';
import jdheLogo from '../../images/jdhe-amravati.png';
import ugcLogo from '../../images/ugc-logo.png';
import rusaLogo from '../../images/rusa-logo.png';
import naacLogo from '../../images/naac-logo.png';
import mahadbtLogo from '../../images/real-mahadbt-logo.png';

const Footer = () => {
  const importantLinks = [
    { id: 1, name: 'SGB Amravati\nUniversity', img: sgbauLogo, url: 'https://sgbau.ac.in/' },
    { id: 2, name: 'Govt. of\nMaharashtra', img: maharashtraLogo, url: 'https://maharashtra.gov.in/' },
    { id: 3, name: 'JDHE,\nAmravati', img: jdheLogo, url: 'https://jdheamravati.org.in/' },
    { id: 4, name: 'UGC', img: ugcLogo, url: 'https://www.ugc.ac.in/' },
    { id: 5, name: 'RUSA', img: rusaLogo, url: 'http://rusa.nic.in/' },
    { id: 6, name: 'NAAC', img: naacLogo, url: 'http://naac.gov.in/' },
    { id: 7, name: 'MAHADBT', img: mahadbtLogo, url: 'https://mahadbtmahait.gov.in/' },
  ];

  return (
    <footer className="site-footer">
      <div className="important-links-section">
        <h2 className="important-links-title">Important Links</h2>
        <div className="links-grid">
          {importantLinks.map(link => (
            <a href={link.url} target="_blank" rel="noreferrer" className="link-card" key={link.id}>
              <div className="link-img-wrapper">
                <img src={link.img} alt={link.name.replace('\n', ' ')} />
              </div>
              <p>{link.name}</p>
            </a>
          ))}
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2005 G.S Tompe Sarvajanik Trust.</p>
        <p>Email: latesanjaytompe_802@rediffmail.com | Phone: +91-9049703918</p>
      </div>
    </footer>
  );
};

export default Footer;